import { render } from "./HR_Shifts_Dialog.vue?vue&type=template&id=d036ba0c&scoped=true&ts=true"
import script from "./HR_Shifts_Dialog.vue?vue&type=script&lang=ts"
export * from "./HR_Shifts_Dialog.vue?vue&type=script&lang=ts"

import "./HR_Shifts_Dialog.vue?vue&type=style&index=0&id=d036ba0c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\khale\\Cookies BIS\\Core\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d036ba0c"]])

export default __exports__